export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const headerHeight = 64;
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-foreground-300">
      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-live-line text-base text-white"></i>
              </div>
              <span className="font-heading text-lg font-bold text-white">51吃瓜网</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              51吃瓜网在线观看 - 国内领先的吃瓜视频在线观看平台，提供51cg吃瓜直播、51吃瓜视频在线、51吃瓜影视免费观看等高清内容，随时随地畅享吃瓜乐趣。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-video-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-sm font-bold text-white mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              <li>
                <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
              </li>
              <li>
                <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
              </li>
              <li>
                <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
              </li>
              <li>
                <a href="#app" onClick={(e) => handleNavClick(e, '#app')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">APP下载</a>
              </li>
            </ul>
          </div>

          {/* Content areas */}
          <div>
            <h3 className="text-sm font-bold text-white mb-4">内容板块</h3>
            <ul className="space-y-2.5">
              <li>
                <a href="#media" onClick={(e) => handleNavClick(e, '#media')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门视频</a>
              </li>
              <li>
                <a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门话题</a>
              </li>
              <li>
                <a href="#carousel" onClick={(e) => handleNavClick(e, '#carousel')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">焦点专题</a>
              </li>
              <li>
                <a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">内容排行</a>
              </li>
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h3 className="text-sm font-bold text-white mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              感谢所有合作伙伴对51吃瓜网在线观看的支持与信任。我们持续寻找优质的吃瓜内容创作者与平台合作伙伴，共同打造更丰富的内容生态。
            </p>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-foreground-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">
            &copy; 2020-2026 51吃瓜网在线观看 版权所有
          </p>
          <p className="text-xs text-foreground-600">
            51吃瓜在线观看 · 51cg吃瓜直播 · 吃瓜在线视频 · 高清影视免费看
          </p>
        </div>
      </div>
    </footer>
  );
}